import { ID, TaskLinkFields } from '@griply/types';

import { linkIdsOf } from './link-ids-of';

export const taskGoalIds = (task: TaskLinkFields): ID[] =>
  linkIdsOf(task.goalIds, task.goalId);

export const taskLifeAreaIds = (task: TaskLinkFields): ID[] =>
  linkIdsOf(task.lifeAreaIds, task.lifeAreaId);

// For surfaces with room for one link — a chip, a colour, a tree slot.
export const primaryGoalId = (task: TaskLinkFields): ID | null =>
  taskGoalIds(task)[0] ?? null;

export const primaryLifeAreaId = (task: TaskLinkFields): ID | null =>
  taskLifeAreaIds(task)[0] ?? null;

// Allocation-free: list rows ask this per item during layout on the hot screens.
export const hasGoalLink = (task: TaskLinkFields): boolean =>
  !!(task.goalIds?.length || task.goalId);

export const hasLifeAreaLink = (task: TaskLinkFields): boolean =>
  !!(task.lifeAreaIds?.length || task.lifeAreaId);

// The one link a single-value surface shows: the goal when there is one, else the life area.
export const primaryLinkId = (task: TaskLinkFields): ID | null =>
  primaryGoalId(task) ?? primaryLifeAreaId(task);
